export enum TechnicalDetailsSteps {
  intro = 'intro',
  continueLater = 'continue-later',
  fuseBox = 'fuse-box',
  electricPhase = 'electric-phase',
  amperage = 'amperage',
  mainFuse = 'main-fuse',
  placement = 'placement',
  distance = 'distance',
  trajectory = 'trajectory',
}
